import { ClientApps } from './constants';

export const getBrandName = () => {
  if (window.isAsco) return 'ascopower';
  if (window.isApc) return 'apc';
  return 'se';
};

// China is a special case — its "country code" comes from the hostname
// TODO: reuse in comparison app
export const isHostnameContainsCC = (): boolean => {
  return window.location.hostname.toLowerCase().endsWith('cn');
};

export const getBodyLanguageCode = (): string => {
  return document.body.getAttribute('locale').split('_')[0]?.toLocaleLowerCase() || '';
};

export const getBodyCountryCode = (): string => {
  return document.body.getAttribute('locale').split('_')[1]?.toLocaleLowerCase() || '';
};

const buildStorageName = () => {
  const brand = getBrandName();
  return `${brand}/${getBodyCountryCode()}/${getBodyLanguageCode()}`;
};

export const getConsumerSpecificData = (isPBS, specificStorageName) => {
  return {
    storageName: isPBS ? specificStorageName : buildStorageName(),
    consumer: isPBS ? ClientApps.PBS : ClientApps.PPW,
  };
};

export const buildLocaleCode = ({
  countryCode,
  languageCode,
}: {
  countryCode: string;
  languageCode: string;
}): string => {
  return `${countryCode}/${languageCode}`;
};

export const formatToLocaleString = (amount: number, locale: string) => {
  return new Intl.NumberFormat(locale).format(amount);
};

export const transformLocaleToBCP47LanguageTag = (locale: string): string => {
  const ERROR_MESSAGE = 'Invalid locale format';

  if (!/^[a-z]{2}-[A-Z]{2}$/.test(locale)) {
    throw new Error(ERROR_MESSAGE);
  }

  const [ languageCode ] = /^[a-z]{2}/.exec(locale);
  const [ countryCode ] = /[A-Z]{2}$/.exec(locale);

  if (!languageCode || !countryCode) {
    throw new Error(ERROR_MESSAGE);
  }

  return `${languageCode}-${countryCode}`;
};
